export function MysticOrb() {
  return (
    <div className="mystic-orb" aria-label="Animated Indra's Net inspired circle">
      <div className="net-ring ring-one" />
      <div className="net-ring ring-two" />
      <div className="net-ring ring-three" />
      <div className="net-thread thread-one" />
      <div className="net-thread thread-two" />
      <div className="net-thread thread-three" />
      <img src="/assets/som-star.png" alt="" className="orb-star" />
      <div className="orb-core">
        <span>Experience</span>
        <strong>Transformation</strong>
        <span>Unity</span>
      </div>
    </div>
  );
}
